import { config } from "../../../config"
import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";

import { getLogo } from "../../../layouts/layout";

import {
    Alert,
    FormGroup,
    Form,
    Row,
    Col,
    Input,
    Button
} from 'reactstrap';

// import img1 from '../../../assets/images/logo-icon-tcs.png';
import img2 from '../../../assets/images/big/auth-bg.jpg';
import { deviceApi } from '../../identity/reducers/identitySlice';

const sidebarBackground = {
    backgroundImage: "url(" + img2 + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center"
};

const ConfirmAccount = () => {
    const { code } = useParams();
    const [confirmCode, setConfirmCode] = useState(code !== undefined ? code : "");
    const confirmStatus = useSelector((state) => state.identityReducer.confirmStatus);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // console.log(confirmStatus);
    if(confirmStatus === true) {
        setTimeout(function(){ navigate("/login"); }, 3000);
    }

    const onCodeChange = (event) => {
        setConfirmCode(event.target.value);  
    }

    const doConfirm = (event) => {
        dispatch( deviceApi.confirmIdentity(confirmCode) );
        event.preventDefault();
    }

    return <div className={config.instance.id} id={config.instance.id}>
        {/*--------------------------------------------------------------------------------*/}
        {/*Recover Password Cards*/}
        {/*--------------------------------------------------------------------------------*/}
        <div className="auth-wrapper d-flex no-block justify-content-center align-items-center" style={sidebarBackground}>
            <div className="auth-box">
                <div id="loginform">
                    <div className="logo">
                        <span className="db"><img src={getLogo()} alt="logo" width="40" height="40" /></span>
                        <h5 className="font-medium mb-3">Confirm account</h5>
                        <p>
                            We have sent you a confirmation code by email.<br/>
                            Insert your confirmation code below and press <b>CONFIRM</b> button. 
                        </p>
                    </div>
                    <Row>
                        <Col xs="12">
                            <Form className="mt-3" id="loginform" action="/">
                                <FormGroup>
                                    <Input 
                                        type="text" 
                                        name="confirmation_code" 
                                        bsSize="lg" 
                                        id="confirmation_code" 
                                        placeholder="your code..." 
                                        required 
                                        value={confirmCode}
                                        onChange={onCodeChange} />
                                </FormGroup>
                                <Row className="mb-4">
                                    <Col xs="12">
                                        <Button color="primary" size="lg" type="submit" className="text-uppercase" block onClick={(event) => doConfirm(event)}>Confirm</Button>
                                    </Col>
                                </Row>
                            </Form>
                            { confirmStatus === true
                                ? <Alert>
                                    The account confirmation code <b>is valid</b>, you will be redirected to the login page... 
                                </Alert> : <></> }
                            { confirmStatus === false
                                ? <>
                                    <Alert color="danger">
                                        The account confirmation code <b>is invalid</b>!
                                    </Alert>
                                    <div className="text-center">
                                        Do you want a new code?
                                        <a href="/new-confirmation" className="text-danger ml-1" >
                                            <b>New code</b>
                                        </a>
                                    </div>
                                </> : <></> }
                            
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    </div>;
}

export default ConfirmAccount;
